<style  scoped>
.per {
  width: 100%;
  padding: 15px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  margin-top: 10px;
  display: flex;
}
.per_left {
  width: 265px;
  height: 226px;
  background: #f9f9f9;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.per_left img {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  margin-top: 30px;
}
.per_left p {
  font-size: 16px;
  color: #333333;
  line-height: 16px;
  margin-bottom: 15px;
}
.per_right {
  width: 815px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  margin-left: 10px;
  padding: 15px;
}
>>> .el-tabs__item {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}
>>> .el-tabs__item.is-active {
  /* color: #e53631; */
  color: #333333;
}
>>> .el-tabs__item:hover {
  /* color: #e53631; */
  color: #333333;
}
>>> .el-tabs__active-bar {
  background-color: #e53631;
}
.release {
  width: 100%;
  height: 70px;
  background: #f9f9f9;
  border-radius: 2px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.release_left {
  width: 75%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info {
  display: flex;
}
.info p {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  line-height: 16px;
}
.info_tag {
  display: flex;
}
.info_tag div {
  font-size: 14px;
  color: #e53631;
  line-height: 14px;
  padding: 1px 4px;
  background: #ffe6e5;
  border-radius: 2px;
  margin-left: 5px;
}
.price {
  font-size: 20px;
  font-weight: 600;
  color: #e53631;
  line-height: 20px;
}
.release_btns {
  display: flex;
}
.edit_btn {
  width: 80px;
  height: 36px;
  background: #ffe6e5;
  border-radius: 2px;
  font-size: 14px;
  color: #e53631;
  line-height: 14px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
}
.delete_btn {
  width: 80px;
  height: 36px;
  background: #c0c0c0;
  border-radius: 2px;
  font-size: 14px;
  color: #fff;
  line-height: 14px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  margin-left: 10px;
}
.edit_btn span,
.delete_btn span {
  margin-left: 6px;
}
>>> .el-pagination {
  text-align: right;
  margin-top: 30px;
}
>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #e53631;
}
.no_apply {
  font-size: 20px;
}
.collection {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
<template>
  <div class="per">
    <div class="per_left">
      <img src="@/assets/img/touxiang.png"
           alt="">
      <p>您好，ID:{{$store.state.loginCode}}</p>
      <p>手机号：{{$store.state.loginPhone}}</p>
    </div>
    <div class="per_right">
      <el-tabs v-model="activeName">
        <el-tab-pane label="我发布的信息"
                     name="first">
          <div class="release_box"
               v-if="myApplyArr.length>0">
            <div class="release"
                 v-for="item in myApplyArr"
                 :key="item.id">
              <div class="release_left">
                <div class="info">
                  <p>{{item.title}}</p>
                  <div class="info_tag"
                       v-if="item.welfare">
                    <div v-for="txt in item.welfare.split(',')"
                         :key="txt">
                      <span v-if="txt==1">包吃</span>
                      <span v-if="txt==2">包住</span>
                      <span v-if="txt==3">交通补贴</span>
                      <span v-if="txt==4">免费培训</span>
                      <span v-if="txt==5">有提成</span>
                    </div>
                  </div>
                </div>
                <p class="price">{{item.salary}}</p>
              </div>
              <div class="release_btns">
                <div class="edit_btn"
                     @click="editInfo(item.jobCode)">
                  <i class="el-icon-edit-outline"></i>
                  <span>编辑</span>
                </div>
                <div class="delete_btn"
                     @click="deleteInfo(item.jobCode)">
                  <i class="el-icon-delete"></i>
                  <span>删除</span>
                </div>
              </div>
            </div>
            <!-- <el-pagination background
                           layout="prev, pager, next"
                           :total="100">
            </el-pagination> -->
          </div>
          <div v-else
               class="no_apply">还未发布信息</div>
        </el-tab-pane>
        <el-tab-pane label="我收藏的兼职"
                     name="second">
          <div v-if="verifyArr.length>0">
            <div class="release"
                 v-for="item in verifyArr"
                 :key="item.jobCode"
                 @click="toDetail(item.jobCode)">
              <div class="collection">
                <div class="info">
                  <p>{{item.title}}</p>
                  <div class="info_tag">
                    <div v-for="txt in item.tag.split(',').slice(0,3)"
                         :key="txt">{{txt}}</div>
                  </div>
                </div>
                <p class="price">{{item.salary}}</p>
              </div>
            </div>
          </div>
          <div class="no_apply"
               v-else>未收藏兼职</div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      myApplyArr: [],//我发布的信息
      verifyArr: [],//我的收藏
    }
  },
  created () {
    this.myApply();
    this.myVerify();
  },
  methods: {
    myApply () {
      this.$get("/app/api/v1/verify/my/job/list", { jobType: 1 })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.myApplyArr = res.data;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((err) => { });
    },
    myVerify () {//我的收藏
      this.$get("/app/api/v1/verify/start/list", { jobType: 1 })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.verifyArr = res.data;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((err) => { });
    },
    toDetail (jobCode) {
      this.$router.push({
        path: "/details",
        query: { jobCode: jobCode },
      });
    },
    editInfo (jobCode) {
      this.$router.push({
        path: "/releaseInfo",
        query: { jobCode: jobCode },
      });
    },
    deleteInfo (jobCode) {
      this.$get("/app/api/v1/verify/del/job", { id: jobCode })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.myApply();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((err) => { });
    }
  }
}
</script>

